import { FOCUSABLE_ELEMENTS, SUBSCRIBE_SERVICE } from '../config/constants';
import addClass from '../utils/dom/addClass';
import click from '../utils/dom/click';
import removeClass from '../utils/dom/removeClass';
import { lockScroll, unlockScroll } from '../utils/dom/scroll';
import { KEY_CODES, KEY_DOWN } from '../utils/keys';

const ON = 'on';
let currentTab = 1;
let focusableContent = null;
// let variant = window.VARIANT;
// let interval = null;

const setupInquire = (variant) => {
  const inquireButton = document.querySelector('button.inquire-button');
  const comingSoonButton = document.querySelector('.coming-soon-button');

  if (!inquireButton) {
    return;
  }

  const bg = document.getElementById('inquire-overlay-background');
  const inquireOverlay = document.getElementById('inquire-overlay');
  const closeInquireOverlay = inquireOverlay.querySelector('.hmr-overlay-close');
  const notifyOverlay = document.getElementById('notify-overlay');
  const closeNotifyOverlay = notifyOverlay.querySelector('.hmr-overlay-close');

  // Only append if not already in the DOM
  if (inquireOverlay && inquireOverlay.parentNode !== document.body) {
    document.body.appendChild(inquireOverlay);
  }

  const onKeyDown = (event) => {
    const isTabPressed = event.key === KEY_CODES.TAB;

    if (event.key === KEY_CODES.ESC) {
      closeOverlays();
      inquireButton.focus();
      return;
    }

    if (!isTabPressed) {
      return;
    }

    if (event.shiftKey) {
      currentTab = currentTab - 1 < 0 ? focusableContent.length - 1 : currentTab - 1;
    } else {
      currentTab = currentTab === focusableContent.length - 1 ? 0 : currentTab + 1;
    }

    event.preventDefault();
    focusableContent[currentTab].focus();
  };

  const onNotifySubmit = async (event) => {
    event.preventDefault();
    const button = notifyOverlay.querySelector('button[type="submit"]');
    const innerHTML = button.innerHTML;

    const firstName = document.getElementById('notify-first-name');
    const lastName = document.getElementById('notify-last-name');
    const email = document.getElementById('notify-email');
    const phone = document.getElementById('notify-phone');

    button.setAttribute('disabled', 'disabled');
    button.innerHTML = 'Submitting...';

    const data = {
      email: email.value,
      firstName: firstName.value,
      lastName: lastName.value,
      phone: phone.value,
      consent: true,
    };
    const request = await fetch(`${SUBSCRIBE_SERVICE}subscribe`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const response = await request.json();

    if (response.ok) {
      const success = notifyOverlay.querySelector('.hmr-overlay .field-success');
      addClass(success, ON);
      success.focus();
    } else {
      alert('There was an error subscribing to the waitlist. Please get in touch.');
    }
    button.removeAttribute('disabled');
    button.innerHTML = innerHTML;
  };

  const closeOverlays = () => {
    const elements = [...inquireOverlay.querySelectorAll(FOCUSABLE_ELEMENTS)];
    elements.forEach((element) => {
      element.setAttribute('tabindex', -1);
    });

    closeInquireOverlay.removeEventListener(click(), closeOverlays);

    const notifyElements = [...notifyOverlay.querySelectorAll(FOCUSABLE_ELEMENTS)];
    notifyElements.forEach((element) => {
      element.setAttribute('tabindex', -1);
    });

    notifyOverlay.querySelector('form').removeEventListener('submit', onNotifySubmit);
    closeNotifyOverlay.removeEventListener(click(), closeOverlays);

    window.removeEventListener(KEY_DOWN, onKeyDown);
    bg.removeEventListener(click(), closeOverlays);
    removeClass(bg, ON);
    removeClass(inquireOverlay, ON);
    removeClass(notifyOverlay, ON);
    unlockScroll();
  };

  const openInquire = () => {
    lockScroll();

    if (variant) {
      const preview = document.getElementById(`inquire-preview-${variant.id}`);
      removeClass(inquireOverlay.querySelector('.inquire-preview.on'), ON);
      addClass(preview, ON);
    }

    addClass(bg, ON);
    addClass(inquireOverlay, ON);

    const elements = [...inquireOverlay.querySelectorAll(FOCUSABLE_ELEMENTS)];
    elements.forEach((element) => {
      element.setAttribute('tabindex', 0);
    });

    currentTab = 1;
    focusableContent = elements;
    focusableContent[0].focus();

    const body = document.getElementById('inquiry-body');
    const details = [
      ...inquireOverlay.querySelectorAll(
        '.inquire-preview.on .inquire-preview-details strong, .inquire-preview.on .inquire-preview-details div div',
      ),
    ];

    let text = 'Product inquiry: ';
    details.forEach((detail) => {
      text += detail.innerText + ' ';
    });
    body.innerText = text;

    closeInquireOverlay.addEventListener(click(), closeOverlays);
  };

  const openNotify = () => {
    lockScroll();

    if (variant) {
      // const preview = document.getElementById(`notify-preview-${variant.id}`);
      removeClass(notifyOverlay.querySelector('.inquire-preview.on'), ON);
      // addClass(preview, ON);
    }
    const success = notifyOverlay.querySelector('.hmr-overlay .field-success');
    removeClass(success, ON);

    addClass(bg, ON);
    addClass(notifyOverlay, ON);

    const elements = [...notifyOverlay.querySelectorAll(FOCUSABLE_ELEMENTS)];
    elements.forEach((element) => {
      element.setAttribute('tabindex', 0);
    });

    currentTab = 1;
    focusableContent = elements;
    focusableContent[0].focus();

    notifyOverlay.querySelector('form').addEventListener('submit', onNotifySubmit);
    closeNotifyOverlay.addEventListener(click(), closeOverlays);
  };

  const openOverlay = (event) => {
    if (event.target.dataset.comingsoon === 'true') {
      openNotify();
    } else {
      openInquire();
    }
    bg.addEventListener(click(), closeOverlays);
    window.addEventListener(KEY_DOWN, onKeyDown);
  };

  inquireButton.addEventListener(click(), openOverlay);
  comingSoonButton?.addEventListener(click(), openOverlay);

  if (window.location.hash === '#inquire-form') {
    const success = inquireOverlay.querySelector('.hmr-overlay .field-success');
    addClass(success, ON);
    inquireButton.click();
    success.focus();
    window.history.replaceState({}, '', `${window.location.pathname}${window.location.search}`);
  }
};
export default setupInquire;
